import { ComponentParams, ComponentRendering } from '@sitecore-jss/sitecore-jss-nextjs';
import { ImportedData } from 'lib/imported-data/ImportedData.types';
import { TranslationOptionsParams, AnchorTargetParams } from 'src/shared/shared.types';

export type I04SparkleLocationOverviewProps = {
  rendering?: ComponentRendering & { params?: ComponentParams };
  params?: ComponentParams & I04SparkleLocationOverviewParams;
  importedData: ImportedData;
};

export type I04SparkleLocationOverviewParams = ComponentParams &
  TranslationOptionsParams &
  AnchorTargetParams;
